$(function() {
    $('.year-datepicker').datepicker({
        minViewMode: 2,
        autoclose: true,
        format: 'yyyy'
    })
})
